import {
    SET_ACADEMIC_PROGRAMS,
    SET_CONTRACT_TYPES,
    SET_SCHEDULES,
    SET_STATES,
    SET_COMPANY,
    SET_OFFERS,
    SET_OFFER,
    SET_APPLICATIONS,
    SET_EDITING_OFFER,
    SET_CANDIDATE,
    SET_OFFER_PREVIEW,
    SET_BUSINESS_SECTORS,
    SET_FORMATIVE_FAMILIES,
    SET_COMPANY_OFFERS_EMULATION,
    SET_COMPANY_OFFERS_COUNT,
    SET_COMPANY_CANDIDATES_COUNT,
    SET_COMPANY_OFFERS_FILTER, SET_COMPANY_OFFERS_APPLICATIONS_FILTER,
} from "./constants";

import {globalCatch} from "../../../_services/global-catch";
import {toastService} from "../../../_services/toast-service";
import {t} from "../../../_i18n";

// singleton
import _svc, {landingSvc, authSvc} from '../../../_services/jobs';
import _svcFixtures from '../../../_services/fixtures';

import {toDic, toKeyName} from "../../../_common/common";
import {
    CompanyCompany,
    CompanyOfferItem,
    CompanyOffersGetRequest,
    CompanyOffersIdGetRequest,
    CompanyOffersIdApplicationsGetRequest,
    CompanyOffer,
    CompanyApplicationItem,
    CompanyApplicationsIdGetRequest,
    CompanyApplication,
    CompanyUser,
    CompanyNewCompany,
    CompanyOffersIdStatusPutRequest,
    CompanyOffersLikeCandidateGetRequest,
    CandidateOfferItem,
    CompanyOffersCountGetRequest,
    OffersCount,
    CandidateOffersCountGetRequest,
    CompanyOffersIdApplicationsCountGetRequest,
    ApplicationsCount,
    CompanyOfferFilters,
    CompanyOffersIdApplicationsFiltersGetRequest,
    CompanyApplicationFilers, CompanyOffersFiltersGetRequest,
} from "../../../_api";

export const setCompany = (payload:CompanyCompany) => ({type: SET_COMPANY, payload});

export const fetchCompany = () => globalCatch.catch(async (dispatch:any) => {
    const company = await _svc().companyCompanyGet();
    dispatch(setCompany(company));
});

export const saveCompany = (companyCompany:CompanyCompany) => globalCatch.catch(async (dispatch:any) => {
    await _svc().companyCompanyPost({companyCompany});
    toastService.showToast({message:t("Los datos se han guardado correctamente"), type:'info'});
    dispatch(fetchCompany());
});

export const saveNewCompany = (companyNewCompany:CompanyNewCompany) => globalCatch.catch(async (dispatch:any) => {
    await landingSvc().newCompanyPost({companyNewCompany});
    toastService.showToast({message:t("Los datos se han guardado correctamente"), type:'info'});
});


export const uploadCompanyLogo = (file:File) => globalCatch.catch(async (dispatch:any) => {
    await _svc().companyLogoPost({file});
    toastService.showToast({message:t("Los datos se han guardado correctamente"), type:'info'});
    dispatch(fetchCompany());
});

export const saveUser = (companyUser:CompanyUser) => globalCatch.catch(async (dispatch:any) => {
    await _svc().companyUserPost({companyUser});
    toastService.showToast({message:t("Los datos se han guardado correctamente"), type:'info'});
});

export const savePassword = (password:string, oldPassword:string) => globalCatch.catch(async (dispatch:any) => {
    await authSvc().companyPasswordPost({companyChangePassword:{password, oldPassword}});
    toastService.showToast({message:t("Los datos se han guardado correctamente"), type:'info'});
});

export const saveEmail = (newEmail: string, password: string) => globalCatch.catch(async (dispatch:any) => {
    await authSvc().companyChangeEmailPost({companyChangeEmail:{newEmail, password}});
    toastService.showToast({message:t("Los datos se han guardado correctamente"), type:'info'});
});


export const setOffers = (payload:CompanyOfferItem[]) => ({type: SET_OFFERS, payload});

export const fetchOffers = (filters:CompanyOffersGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const offers = await _svc().companyOffersGet(filters||{});
    dispatch(setOffers(offers as any));
});

export const clearOffers = () => setOffers({payload: null} as any);

export const setCompanyOfferEmulation = (payload: CandidateOfferItem[])=>({type: SET_COMPANY_OFFERS_EMULATION, payload});

export const fetchCompanyOffersEmulation = (filters: CompanyOffersLikeCandidateGetRequest) => globalCatch.catch(async (dispatch: any) => {
    const companyOffer = await _svc().companyOffersLikeCandidateGet(filters||{});
    dispatch(setCompanyOfferEmulation(companyOffer));
});

export const setCompanyOffersFilter = (payload: CompanyOfferFilters) => ({type: SET_COMPANY_OFFERS_FILTER, payload});
export const fetchCompanyOffersFilter = (filters: CompanyOffersFiltersGetRequest) => globalCatch.catch(async (dispatch: any) => {
   const companyOffersFilter = await _svc().companyOffersFiltersGet(filters||{});
   dispatch(setCompanyOffersFilter(companyOffersFilter));
});

export const setCompanyOffersApplicationsFilter = (payload: CompanyApplicationFilers) => ({type: SET_COMPANY_OFFERS_APPLICATIONS_FILTER, payload});
export const fetchCompanyOffersApplicationsFilter = (filters: CompanyOffersIdApplicationsFiltersGetRequest) => globalCatch.catch(async (dispatch: any) => {
    const companyOffersApplicationsFilter = await _svc().companyOffersIdApplicationsFiltersGet(filters||{});
    dispatch(setCompanyOffersApplicationsFilter(companyOffersApplicationsFilter));
});

export const setCompanyOffersCount = (payload: OffersCount) => ({type: SET_COMPANY_OFFERS_COUNT, payload});
export const fetchCompanyOffersCount = (filters: CompanyOffersCountGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const companyOffersCount = await _svc().companyOffersCountGet(filters||{});
    dispatch(setCompanyOffersCount(companyOffersCount));
});

export const setCandidatesCount = (payload: ApplicationsCount) => ({type: SET_COMPANY_CANDIDATES_COUNT, payload});
export const fetchCandidatesCount = (filters: CompanyOffersIdApplicationsGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const companyCandidatesCount = await _svc().companyOffersIdApplicationsCountGet(filters||{});
    dispatch(setCandidatesCount(companyCandidatesCount));
});

export const setOffer = (payload:CompanyOffer) => ({type: SET_OFFER, payload});
export const clearOffer = () => ({type: SET_OFFER, payload: null});

export const fetchOffer = (filters:CompanyOffersIdGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const offer = await _svc().companyOffersIdGet(filters||{});
    dispatch(setOffer(offer));
});


export const setEditingOffer = (payload:CompanyOffer) => ({type: SET_EDITING_OFFER, payload});

export const fetchEditingOffer = (filters:CompanyOffersIdGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const offer = await _svc().companyOffersIdGet(filters||{});
    dispatch(setEditingOffer(offer));
});

export const saveEditingOffer = (offer:CompanyOffer, redirectObject: any) => globalCatch.catch(async (dispatch:any) => {
    const {history, url} = redirectObject;

    if(Array.isArray(offer.benefits)) {
        offer = {...offer};
        offer.benefits = JSON.stringify(offer.benefits as any);
    }

    if(typeof (offer as any).schedule === 'object') {
        offer = {...offer};
        offer.schedule = (offer as any).schedule.id;
    }

    if(offer.id){
        // alert(offer.salaryMax)
        await _svc().companyOffersIdPut({id:offer.id, companyOffer:offer});
    }
    else {
        // alert(offer.salaryMax + 'post')
        await _svc().companyOffersPost({companyOffer:offer});
    }

    toastService.showToast({message:t("Los datos se han guardado correctamente"), type:'info'});
    history.push(url)
    fetchEditingOffer({id: offer.id as any})
});

export const setOfferPreview = (payload:CompanyUser) => ({type: SET_OFFER_PREVIEW, payload});
export const clearOfferPreview = () => ({type: SET_OFFER_PREVIEW, payload: null});


export const fetchOfferPreview = (filters:CompanyOffersIdGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const offer: any = await _svc().companyOffersIdGet(filters||{});
    dispatch(setOfferPreview(offer));
});


export const setApplications = (payload:CompanyApplicationItem) => ({type: SET_APPLICATIONS, payload});
export const clearApplications = () => ({type: SET_APPLICATIONS, payload: null});

export const fetchApplications = (filters:CompanyOffersIdApplicationsGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const applicationItems: any = await _svc().companyOffersIdApplicationsGet(filters||{});
    dispatch(setApplications(applicationItems));
});

export const setCandidate = (payload:CompanyApplication) => ({type: SET_CANDIDATE, payload});
export const clearCandidate = () => ({type: SET_CANDIDATE, payload: null});

export const fetchCandidate = (filters:CompanyApplicationsIdGetRequest) => globalCatch.catch(async (dispatch:any) => {
    const candidateItems: any = await _svc().companyApplicationsIdGet(filters||{});
    dispatch(setCandidate(candidateItems));
});

export const changeCandidateStatus = (applicationId:number, newStatus: string) => globalCatch.catch(async (dispatch:any) => {
    await _svc().companyApplicationsIdPut({id:applicationId, status: {status: newStatus}});
    toastService.showToast({message:t("Se ha modificado la candidatura correctamente"), type:'info'});
});


//async companyOffersIdStatusPut(requestParameters: CompanyOffersIdStatusPutRequest): Promise<boolean> {

export const updateOfferStatus = (requestParameters: CompanyOffersIdStatusPutRequest) => globalCatch.catch(async (dispatch:any) => {
    await _svc().companyOffersIdStatusPut(requestParameters);
    toastService.showToast({message:t("Se ha modificado la oferta correctamente"), type:'info'});
});

///////////////////// FIXTURES


export const setStates = (dic:any, kn:any) => ({type: SET_STATES, payload:{dic,kn}});

export const fetchStates = () => globalCatch.catch(async (dispatch:any) => {
    const data: any[] = await _svcFixtures().fixturesStatesGet();
    dispatch(setStates(toDic(data), toKeyName(data)));
});


export const setAcademicPrograms = (dic:any, kn:any) => ({type: SET_ACADEMIC_PROGRAMS, payload:{dic,kn}});

export const fetchAcademicPrograms = () => globalCatch.catch(async (dispatch:any) => {
    let data: any[] = await _svcFixtures().fixturesAcademicProgramsGet();
    dispatch(setAcademicPrograms(toDic(data), toKeyName(data)));
});


export const setSchedules = (dic:any, kn:any) => ({type: SET_SCHEDULES, payload:{dic,kn}});

export const fetchSchedules = () => globalCatch.catch(async (dispatch:any) => {
    const data: any[] = await _svcFixtures().fixturesSchedulesGet();
    dispatch(setSchedules(toDic(data), toKeyName(data)));
});

export const setContractTypes = (dic:any, kn:any) => ({type: SET_CONTRACT_TYPES, payload:{dic,kn}});

export const fetchContractTypes = () => globalCatch.catch(async (dispatch:any) => {
    const data: any[] = await _svcFixtures().fixturesContractTypesGet();
    dispatch(setContractTypes(toDic(data), toKeyName(data)));
});

export const setBusinessSectors = (dic:any, kn:any) => ({type: SET_BUSINESS_SECTORS, payload:{dic,kn}});

export const fetchBusinessSectors = () => globalCatch.catch(async (dispatch: any) => {
    const data: any[] = await _svcFixtures().fixturesBusinessSectorsGet();
    dispatch(setBusinessSectors(toDic(data), toKeyName(data)));
});

export const setFormativeFamilies = (dic:any, kn:any) => ({type: SET_FORMATIVE_FAMILIES, payload:{dic,kn}});

export const fetchFormativeFamilies = () => globalCatch.catch(async (dispatch: any) => {
    const data: any[] = await _svcFixtures().fixturesFormativeFamiliesGet();
    dispatch(setFormativeFamilies(toDic(data), toKeyName(data)));
});
